<template>
  <div class="home">
    <MainBanner />
    <ProductCarousel />
    <EbooksCarousel />
    <InfoSection />
    <TestimonialsSection />
    <section class="container">
       </section>
  </div>
</template>

<script setup lang="ts">
import MainBanner from '@/components/sections/MainBanner.vue';
import EbooksCarousel from '@/components/sections/EbooksCarousel.vue';
import InfoSection from '@/components/sections/InfoSection.vue';
import TestimonialsSection from '@/components/sections/TestimonialsSection.vue';
// ... outros imports
</script>